import * as React from "react";
import { forwardRef } from "react";
const SvgSidebarClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-panel-right-close-icon lucide-panel-right-close", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 18, x: 3, y: 3, rx: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M15 3v18" }), /* @__PURE__ */ React.createElement("path", { d: "m8 9 3 3-3 3" }));
const ForwardRef = forwardRef(SvgSidebarClose);
export default ForwardRef;
